import { Bloc } from "@lib/bloc/Bloc"
import {
    PageLoadTrend,
    PagePerformanceRow,
    PerformanceOverview,
    PerformanceService,
} from "@service/performance/PerformanceService"

export interface PerformanceState {
    isLoading: boolean
    isConfigured: boolean
    overview: PerformanceOverview | null
    last24HoursTrend: PageLoadTrend | null
    last30DaysTrend: PageLoadTrend | null
    perPageMetrics: PagePerformanceRow[]
    error: string | null
}

export class PerformanceBloc extends Bloc<PerformanceState> {
    constructor(private performanceService: PerformanceService) {
        super({
            isLoading: false,
            isConfigured: performanceService.isConfigured(),
            overview: null,
            last24HoursTrend: null,
            last30DaysTrend: null,
            perPageMetrics: [],
            error: null,
        })
    }

    loadDashboard = async (): Promise<void> => {
        if (!this.performanceService.isConfigured()) return

        this.update({ isLoading: true, error: null })

        const [overviewResult, trend24hResult, trend30dResult, perPageResult] = await Promise.all([
            this.performanceService.fetchOverview(),
            this.performanceService.fetchLast24HoursTrend(),
            this.performanceService.fetchLast30DaysTrend(),
            this.performanceService.fetchPerPageMetrics(),
        ])

        const errors: string[] = []
        if (overviewResult.isError()) errors.push(overviewResult.error)
        if (trend24hResult.isError()) errors.push(trend24hResult.error)
        if (trend30dResult.isError()) errors.push(trend30dResult.error)
        if (perPageResult.isError()) errors.push(perPageResult.error)

        this.update({
            isLoading: false,
            overview: overviewResult.isOk() ? overviewResult.value : null,
            last24HoursTrend: trend24hResult.isOk() ? trend24hResult.value : null,
            last30DaysTrend: trend30dResult.isOk() ? trend30dResult.value : null,
            perPageMetrics: perPageResult.isOk() ? perPageResult.value : [],
            error: errors.length > 0 ? errors[0] : null,
        })
    }
}
